import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParentService {

  constructor(private http: HttpClient) { }
  private token = '';

  postlogin(payload: any) {
    const headers = new HttpHeaders({
      // 'Authorization': 'Basic cGFyZW50OnNlY3JldA==',
      // "Content-Type": 'application/x-www-form-urlencoded'
    });
    return this.http.post(environment.printasseturl + '/student/login/v2/api/common/login', payload, { headers })
  }

  accountDelete(admNo: any, deviceSessionId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.parentReport + 'student/jwt/v2/inactiveParentAppAccount?admNo=' + admNo + '&deviceSessionId=' + deviceSessionId, { headers })
  }
}

